/**
 * @requires ../node_modules/slick-carousel/slick/slick.js
 */

'use strict';

;( $ => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'slick', () => ({

			cssEasing            : getComputedStyle( document.documentElement ).getPropertyValue( '--css-easing' ).trim(),
			previousGaugePosition: '50%',
			previousRadarRotation: '0deg',

			init() {
				const sliderEl   = this.$el;
				const sliderName = sliderEl.dataset.slick;
				const $slider    = $( this.$el ).find( '.slides' );
				const options    = {
					appendDots  : sliderEl.querySelector( '.slick-dots-container' ),
					cssEase     : this.cssEasing,
					mobileFirst : true,
					nextArrow   : sliderEl.querySelector( '.slick-arrow-next button' ),
					pauseOnHover: false,
					prevArrow   : sliderEl.querySelector( '.slick-arrow-prev button' ),
					speed       : 1200,
				};

				// Handle prefers-reduced-motion.
				if ( window.matchMedia( '( prefers-reduced-motion: reduce )' ).matches ) {
					options.fade = true;
				}

				// Custom options per slider.
				switch ( sliderName ) {

				case 'product-slider':
					options.arrows          = false;
					options.autoplay        = true;
					options.autoplaySpeed   = 3000;
					options.dots            = false;
					options.draggable       = false;
					options.infinite        = true;
					options.mobileFirst     = true;
					options.vertical        = true;
					options.verticalSwiping = true;
					break;

				case 'solutions-feed':
				case 'news-feed':
					options.dots       = true;
					options.infinite   = false;
					options.responsive = [
						{
							breakpoint: 991,
							settings  : 'unslick',
						}
					];
					break;

				case 'image-grid':
				case 'testimonials':
					options.autoplay = false;
					options.dots     = true;
					options.infinite = true;
					break;

				case 'testimonials':
					options.autoplay      = true;
					options.autoplaySpeed = 3000;
					options.dots          = true;
					options.infinite      = true;
					break;

				case 'post-carousel':
				case 'media-carousel':
					options.dots     = true;
					options.fade     = true;
					options.infinite = false;
					break;

				case 'model-3d':
					options.dots     = true;
					options.fade     = true;
					options.infinite = true;
					break;

				case 'logo-gallery':
					options.autoplay      = true;
					options.autoplaySpeed = 3000;
					options.dots          = true;
					options.infinite      = true;
					options.responsive    = [
						{
							breakpoint: 991,
							settings  : 'unslick',
						}
					];
					break;
				}

				this.startSlider( $slider, sliderEl, sliderName, options );

				// Create a resizeObserver to reinitialize sliders on resize.
				const resizeObserver = new ResizeObserver( entries => {

					for ( let entry of entries ) {

						if (
							992 > entry.contentRect.width &&
							( 'solutions-feed' === sliderName || ( 'news-feed' === sliderName ) || ( 'logo-gallery' === sliderName ) ) &&
							! $slider.hasClass( 'slick-initialized' )
						) this.startSlider( $slider, sliderEl, sliderName, options );

						if ( 'model-3d' === sliderName ) this.model3dDrawLines( sliderEl );
					}
				});

				resizeObserver.observe( sliderEl );
			},

			startSlider( $slider, sliderEl, sliderName, options ) {

				$slider
					.on( 'init', () => {
						sliderEl.classList.remove( 'opacity-0' );
						if ( 'model-3d' === sliderName ) this.model3dDrawLines( sliderEl );
					})
					.on( 'beforeChange', () => {
						if ( 'product-slider' === sliderName ) this.productSliderInit();
					})
					.slick( options );
			},

			/**
			 * For the 3D model slider, draw a right-angle callout connector from
			 * each slide's focus-point dot to its text block. The connector is a
			 * div with white borders on two sides forming an L-shape; the elbow
			 * is always at (textCenterX, dotY). The text block sits above the
			 * connector via z-index, and its background covers the overlap.
			 */
			model3dDrawLines( sliderEl ) {
				const slides = sliderEl.querySelectorAll( '.slide' );

				slides.forEach( slide => {
					const dot       = slide.querySelector( '[data-focus-dot]' );
					const textBlock = slide.querySelector( '[data-text-block]' );

					if ( ! dot || ! textBlock ) {
						return;
					}

					const slideRect = slide.getBoundingClientRect();
					const dotRect   = dot.getBoundingClientRect();
					const textRect  = textBlock.getBoundingClientRect();

					const dotX   = dotRect.left + dotRect.width / 2 - slideRect.left;
					const dotY   = dotRect.top + dotRect.height / 2 - slideRect.top;
					const textCX = textRect.left + textRect.width / 2 - slideRect.left;
					const textCY = textRect.top + textRect.height / 2 - slideRect.top;

					// The box spans from the dot center to the text block center.
					// The elbow of the L is at (textCX, dotY): horizontal from dot, then vertical to text center.
					const boxLeft   = Math.min( dotX, textCX );
					const boxTop    = Math.min( dotY, textCY );
					const boxWidth  = Math.abs( textCX - dotX );
					const boxHeight = Math.abs( textCY - dotY );

					// Which two sides carry the border depends on relative positions.
					const horizBorder = dotY <= textCY ? 'border-top' : 'border-bottom';
					const vertBorder  = dotX <= textCX ? 'border-right' : 'border-left';

					let box = slide.querySelector( '[data-connector-box]' );

					if ( ! box ) {
						box = document.createElement( 'div' );
						box.setAttribute( 'data-connector-box', '' );
						box.setAttribute( 'aria-hidden', 'true' );
						slide.appendChild( box );
					}

					box.style.position       = 'absolute';
					box.style.pointerEvents  = 'none';
					box.style.zIndex         = '1';
					box.style.left           = boxLeft + 'px';
					box.style.top            = boxTop + 'px';
					box.style.width          = boxWidth + 'px';
					box.style.height         = boxHeight + 'px';
					box.style.borderTop      = '';
					box.style.borderBottom   = '';
					box.style.borderLeft     = '';
					box.style.borderRight    = '';
					box.style[ horizBorder ] = '1px solid white';
					box.style[ vertBorder ]  = '1px solid white';
				});
			},

			/**
			 * For the front page product slider, we have some extra animations
			 * to implement.
			 */
			productSliderInit() {

				// For each slide change, pick a value of positions at
				// random, and set the --background-position-y to that
				// value.
				const gauge          = this.$refs.gauge;
				const gaugePositions = [ '40%', '50%', '60%', '70%' ];

				let newPosition = gaugePositions[ Math.floor( Math.random() * gaugePositions.length ) ];

				while ( newPosition === this.previousGaugePosition )
					newPosition = gaugePositions[ Math.floor( Math.random() * gaugePositions.length ) ];

				this.previousGaugePosition = newPosition;
				gauge.style.setProperty( '--background-position-y', newPosition );

				// Do the same with the radar rotation. Rotation should
				// be between -90deg and 90deg.
				const radar = this.$refs.radar;

				let newRotation = `${ Math.floor( Math.random() * 180 - 90 ) }deg`;

				while ( newRotation === this.previousRadarRotation )
					newRotation = `${ Math.floor( Math.random() * 180 - 90 ) }deg`;

				this.previousRadarRotation = newRotation;
				radar.style.setProperty( '--rotation', newRotation );
			},
		}) );
	});
})( jQuery );
